export default __webpack_public_path__ + "static/media/data-analysis-1.d9d535bf.png";